import { useEffect, useState } from 'react';

/**
 * Returns true once `idleMs` has elapsed without any user interaction
 * (mousemove, mousedown, keydown, touchstart, scroll). The bell uses this
 * to gate its polling — there's no reason to hammer the backend if the
 * user has walked away from the tab.
 */
export function useIdleTimeout(idleMs: number): boolean {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    const reset = () => {
      if (isIdle) setIsIdle(false);
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => setIsIdle(true), idleMs);
    };

    const events: Array<keyof WindowEventMap> = [
      'mousemove',
      'mousedown',
      'keydown',
      'touchstart',
      'scroll',
    ];
    events.forEach((ev) =>
      window.addEventListener(ev, reset, { passive: true }),
    );
    reset();

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, reset));
      if (timer) clearTimeout(timer);
    };
  }, [idleMs, isIdle]);

  return isIdle;
}
